import DialogFactory from '@kso/ui/lib/Dialog';
import '@kso/ui/lib/Dialog/style.css';
import KCopyLink from '@kso/ui/lib/CopyLink';
import '@kso/ui/lib/CopyLink/style.css';
import { t } from '@kso/ui/lib/config/locale';

var classname = function classname(name) {
  return "k-dialog-".concat(name, "-layout");
};
var index = DialogFactory({
  entry: KCopyLink,
  pages: [{
    title: t('logic.CopyLink.txt4'),
    className: classname('copy-link'),
    width: '600px',
    body: KCopyLink,
    footer: null,
    closeOnClickModal: false
  }]
});

export { index as default };
